export default __webpack_public_path__ + "static/media/3-Cloudxier-PTBIS.485eac77.png";